import { render, staticRenderFns } from "./EventEntry.vue?vue&type=template&id=615677ae&"
import script from "./EventEntry.vue?vue&type=script&lang=js&"
export * from "./EventEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports